<template>
  <div id="grid-ingreso">
    <v-container>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>

      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Región"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoAppValue"
            :items="tipoAppSelect"
            label="Tipo aplicacion"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="versionValue"
            :items="versionSelect"
            label="Version"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadDataFiltro()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-data-table
            :headers="headers"
            :items="itemsIngreso"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>
                {{
                  props.item.idRegion != null ? props.item.idRegion.nombre : "-"
                }}
              </td>
              <td class="text-xs-left">{{ props.item.idNivel.descripcion }}</td>
              <td class="text-xs-left">
                {{ props.item.idTipoAplicacion.descripcion }}
              </td>
              <td class="text-xs-left">{{ props.item.cantidadRBD }}</td>
              <td class="text-xs-left">
                {{ props.item.cantidadRbdAplicados }}
              </td>
              <td class="text-xs-left">{{ props.item.porcentajeAplicados }}</td>
              <td class="text-xs-left">{{ props.item.fechaCarga }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Consulta datos"
                  @click="view(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Consulta Datos
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="itemsIngreso.length"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="downloadCompleted()"
          >Descarga Completa</v-btn
        >
        <v-btn color="primary" @click="downloadFiltered()"
          >Descarga Filtrada</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-ingreso-cursos",

  components: {
    Loading,
    AlertEmpty,
    LoadingDescarga,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogValidation: false,
      botonValida: 1,
      dialogLoading: false,
      botonProcesar: false,
      botonCargar: true,
      loading: false,
      loading1: false,
      alerta: false,
      respOk: false,
      botonDescarga: false,
      dialogArchivo: false,
      resp: "",
      id: "",
      idContrato: "",
      headers: [
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Tipo aplicacion", sortable: false, value: "tipoApp" },
        { text: "Cantidad de RBD", sortable: false, value: "cantidadrbd" },
        {
          text: "Cantidad RBD Aplicados",
          sortable: false,
          value: "cantidadrbdapp",
        },
        {
          text: "Porcentaje de Aplicados",
          sortable: false,
          value: "porcentajeapl",
        },
        {
          text: "Fecha Carga Reporte",
          sortable: false,
          value: "fechaCargaReporte",
        },
        { text: "Acciones", sortable: false, value: "" },
      ],
      usuarioLoggedTipe: "",
      itemsIngreso: [],
      idUserLogged: "",
      proceso: "",
      regionValue: null,
      regionSelect: [],
      nivelSelect: [],
      nivelValue: null,
      tipoAppSelect: [],
      tipoAppValue: null,
      versionSelect: [],
      versionValue: null,
      tipeArchive: "",
      btnHidden: false,
      tab: "",
      tabSelected: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    //se indican las apis a utilizar
    this.apiValidateDocument = "/reporte6A/preProcessReporte6A";
    this.apiSaveDocument = "/reporte6A/GuardarReporte6A";
    this.apiDownloadDocument = "/reporte6A/downloadExcelReporteA/";
    this.templateTitle = "Planilla_Ingresos_Cursos_RBD";

    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    view(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "FormIngresoCursoApli",
          params: { idIngreso: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    async loadIngresoFilter() {
      this.regionValue = "";
      this.nivelValue = "";
      this.tipoAppValue = "";
      this.versionValue = "";
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
      };

      return await axios
        .post("/reporte6A/getAllFilterReporteA", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsIngreso = await this.loadIngresoFilter();

      this.miPaginacion.totalItems = this.itemsIngreso.length;
      if (this.itemsIngreso.length > 0) {
        this.loadRegionSelect();
        this.loadNivelSelect();
        this.loadTipoAppSelect();
        this.loadVersionSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
        this.regionSelect = [];
        this.nivelSelect = [];
        this.tipoAppSelect = [];
        this.versionSelect = [];
      }
      this.loading = false;
    },

    downloadFiltered() {
      this.dialogLoading = true;
      let fileName = "Registro_Ingreso_Cursos_RBD.xlsx";

      if (this.txtBusqueda != "") {
        this.body = {
          idContrato: this.idContrato,
          proceso: this.proceso,
          txtBusqueda: this.txtBusqueda,
        };
      } else {
        this.body = {
          idRegion:
            this.regionValue && this.regionValue != null
              ? this.regionValue
              : null,

          idNivel:
            this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
          idTipoAplicacion:
            this.tipoAppValue && this.tipoAppValue != null
              ? this.tipoAppValue
              : null,
          version:
            this.versionValue && this.versionValue != null
              ? this.versionValue
              : null,
          idContrato: this.idContrato,
        };
      }

      axios
        .post("/reporte6A/writeObjectToReporteA", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    downloadCompleted() {
      this.dialogLoading = true;
      let fileName = "Registro_Ingreso_Cursos_RBD.xlsx";

      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: "",
      };

      axios
        .post("/reporte6A/writeObjectToReporteA", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
    async loadIngresoFiltro() {
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idRegion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,

        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        idTipoAplicacion:
          this.tipoAppValue && this.tipoAppValue != null
            ? this.tipoAppValue
            : null,
        version:
          this.versionValue && this.versionValue != null
            ? this.versionValue
            : null,
        idContrato: idContrato,
      };

      return await axios
        .post("/reporte6A/getAllFilterReporteA", this.body)
        .then(function (response) {
          // console.log("aaa:" + response.data.length);
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadDataFiltro() {
      this.loading = true;
      this.txtBusqueda = "";
      console.log("llama:" + this.itemsIngreso.length);
      this.itemsIngreso = await this.loadIngresoFiltro();
      console.log("traeeeee:" + this.itemsIngreso.length);
      this.miPaginacion.totalItems = this.itemsIngreso.length;

      if (this.itemsIngreso.length > 0) {
        this.loadRegionSelect();
        this.loadNivelSelect();
        this.loadTipoAppSelect();
        this.loadVersionSelect();
        this.alerta = false;
      } else {
        this.alerta = true;

        this.regionSelect = [];
        this.nivelSelect = [];
        this.tipoAppSelect = [];
        this.versionSelect = [];
      }
      this.loading = false;
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsIngreso.forEach(function (d) {
        if (d.idNivel != null) {
          let index = niv.findIndex((x) => x.code == d.idNivel.codNivelAce);
          if (index === -1) {
            if (d.idNivel != null && d.idNivel != "") {
              niv.push({
                name: d.idNivel.descripcion,
                code: d.idNivel.id,
              });
            }
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadRegionSelect() {
      let reg = [];
      this.itemsIngreso.forEach(function (d) {
        if (d.idRegion != null) {
          let index = reg.findIndex((x) => x.code == d.idRegion.codigo);
          if (index === -1) {
            if (d.idRegion != null && d.idRegion != "") {
              reg.push({
                name: d.idRegion.nombre,
                code: d.idRegion.codigo,
              });
            }
          }
        }
      });
      this.regionSelect = reg;
    },
    loadVersionSelect() {
      let reg = [];
      this.itemsIngreso.forEach(function (d) {
        if (d.version != null) {
          let index = reg.findIndex((x) => x.code == d.version);
          if (index === -1) {
            if (d.version != null && d.version != "") {
              reg.push({
                name: "Versión " + d.version + " | Fecha: " + d.fechaCarga,
                code: d.version,
              });
            }
          }
        }
      });
      this.versionSelect = reg;
    },
    loadTipoAppSelect() {
      let tip = [];
      this.itemsIngreso.forEach(function (t) {
        let index = tip.findIndex(
          (x) => x.idTipoAplicacion == t.idTipoAplicacion.id
        );
        if (index === -1) {
          if (t.idTipoAplicacion != null && t.idTipoAplicacion != "") {
            tip.push({
              name: t.idTipoAplicacion.descripcion,
              code: t.idTipoAplicacion.id,
            });
          }
        }
      });
      this.tipoAppSelect = tip;
    },

    clear() {
      this.regionValue = "";
      this.nivelValue = "";
      this.tipoAppValue = "";
      this.versionValue = "";
      this.loadData();
    },
  },
};
</script>
